import React , { useContext } from 'react';
import ButtonStyle from './HeaderCardButton.module.css';

import CartIcon from '../Cart/CartIcon';
import CartContext from '../../store/cart-contex';

function HeaderCardButton(props) {

  const cartCtx = useContext(CartContext)

  const numberOfCartItems = cartCtx.items.reduce((curNumber , item) => {return curNumber + item.amount} , 0) ;


  return (
    <button className={ButtonStyle.button} onClick={props.onClick}>
        <span className={ButtonStyle.icon}>
            <CartIcon />
        </span>
        <span className={ButtonStyle.text}> Your Cart</span>
        <span className={ButtonStyle.badge}>{numberOfCartItems}</span>
    </button>
  )
}

export default HeaderCardButton;